import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableSerialNumberTrackingPhase2 = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enableSerialNumberTrackingPhase2);
};
